const motorTrabalhista = (dados) => {

  let fatos = [];
  let fundamentos = [];
  let pedidos = [];

  // 🔥 HELPER CENTRALIZADO (SEM DUPLICAÇÃO)
  const adicionarPedido = (p) => {
    const pedido = String(p).trim();
    if (pedido && !pedidos.includes(pedido)) {
      pedidos.push(pedido);
    }
  };

  // 🔹 DADOS
  const nome = dados.nomeCliente || "Reclamante";
  const cpf = dados.identificacao?.cpf || "";
  const empresa = dados.contrato?.empresa || "Reclamada";
  const funcao = dados.contrato?.funcao || "função não informada";
  const admissao = dados.contrato?.dataAdmissao || "";
  const demissao = dados.contrato?.dataDemissao || "";

  const fatosExtra = (dados.juridico?.fatos || "");
  const pedidosInput = dados.juridico?.pedidos || "";

  // 🔥 CONTEXTO MELHORADO PARA ANÁLISE
  const textoAnalise = `
    ${fatosExtra}
    ${dados.contrato?.empresa || ""}
    ${dados.contrato?.funcao || ""}
    ${admissao}
    ${demissao}
  `.toLowerCase();

  // 🧾 FATOS
  fatos.push(
    `${nome}, inscrito no CPF ${cpf}, exerceu a função de ${funcao} junto à empresa ${empresa}, no período de ${admissao} até ${demissao}.`
  );

  if (fatosExtra) {
    fatos.push(fatosExtra);
  }

  // ⚖️ FUNDAMENTOS BASE
  fundamentos.push(
    "Nos termos dos artigos 2º e 3º da CLT, resta configurada a relação de emprego."
  );

  fundamentos.push(
    "O descumprimento das obrigações trabalhistas impõe a devida reparação."
  );

  // 🧠 REGRAS INTELIGENTES

  // 🔸 Sem registro
  if (
    textoAnalise.includes("sem registro") ||
    textoAnalise.includes("não assinou carteira")
  ) {
    adicionarPedido("Reconhecimento de vínculo empregatício");
    adicionarPedido("Anotação na CTPS");
  }

  // 🔸 Hora extra
  if (
    textoAnalise.includes("hora extra") ||
    textoAnalise.includes("horas extras")
  ) {
    adicionarPedido("Pagamento de horas extras");

    fundamentos.push(
      "Nos termos do art. 7º, XVI da Constituição Federal, são devidas horas extras."
    );
  }

  // 🔸 FGTS
  if (textoAnalise.includes("fgts")) {
    adicionarPedido("Depósito do FGTS não recolhido");
  }

  // 🔸 Verbas rescisórias
  if (
    textoAnalise.includes("demissão") ||
    textoAnalise.includes("dispensa")
  ) {
    adicionarPedido("Pagamento de verbas rescisórias");
  }

  // 🔸 Dano moral
  if (
    textoAnalise.includes("humilhação") ||
    textoAnalise.includes("assédio")
  ) {
    adicionarPedido("Indenização por danos morais");

    fundamentos.push(
      "A conduta da reclamada configura violação à dignidade do trabalhador."
    );
  }

  // 🔸 PEDIDOS DO BACKEND (ROBUSTO)
  if (Array.isArray(pedidosInput)) {
    pedidosInput.forEach(p => adicionarPedido(p));
  } 
  else if (typeof pedidosInput === "string") {
    pedidosInput.split(",").forEach(p => adicionarPedido(p));
  }

  // 🔒 GARANTIA MÍNIMA (fallback)
  if (pedidos.length === 0) {
    adicionarPedido("Condenação da reclamada conforme apuração");
  }

  return {
    termosPartes: {
      autor: "RECLAMANTE",
      reu: "RECLAMADA",
      nomePeticao: "RECLAMAÇÃO TRABALHISTA"
    },
    fatos,
    fundamentos,
    pedidos,
    valorCausa: "10.000,00"
  };
};

export default motorTrabalhista;